import Rails from "@rails/ujs"

function passwordRecovery() {

  // VARS FOR SCRIPT
  // VAR : RECOVERY BUTTON FOR LISTENER
  var recoveryButton = document.getElementById("passwordRrecoveryButton");

  // LISTEN FOR A CLICK ON THE PASSWORD RECOVRY BUTTON
  recoveryButton.addEventListener("click", function (event) {

    // VAR : EMAIL VALUE
    var email = document.querySelector(".email-recovery-field").value
    // VAR : AUTH TOKEN
    var authenticity_token = document.querySelector('[name="authenticity_token"]').value

    // PREVENT DEFAUL BEHAVIOUR : SEND THE FORM
    event.preventDefault();
    // console.log("click on passwordRecoveryButton");

    // DEFINE DATA TO BE SEND TO THE AJAX CALL
    var myData = [
      "user[email]=" + email,
      "authenticity_token=" + authenticity_token,
    ];

    // RE-SHAPE THE VARS FOR THE RUBY'S CONTROLLER
    var myDataToSend = myData.join("&");

    // console.log(email);
    // console.log(myData);
    // console.log(myDataToSend);

    // RAILS AJAX CALL TO PASSWORD RECOVERY OPTION
    Rails.ajax({
      url: "/users/password",
      type: "POST",
      // TODO: UNDERSTAND THE DIFFERENCES FOR DATATYPE
      // dataType: "JSON",
      data: myDataToSend,
      success: function (response) {
        // console.log("SUCCESS : " + response);
        // console.log(response);
      },
      error: function (request, error) {
        // console.log("ERROR : " + error);
      }
    });
  })
}

passwordRecovery();